import { DependencyList, useRef, useEffect } from 'react';
import { ICallback } from '../interfaces/ICallback';

const useAfterUpdate = (callback: ICallback, deps: DependencyList): void => {
    const didMountRef = useRef<boolean>(false);

    useEffect(() => {
        if (!didMountRef.current || typeof callback !== 'function') {
            didMountRef.current = true;
            return undefined;
        }

        return callback();
    }, deps);
};

export default useAfterUpdate;
